import React from 'react'
import { QueryClientProvider as BaseQueryClientProvider, QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient()

const QueryClientProvider: React.FC = ({ children }) => {
  return <BaseQueryClientProvider client={queryClient}>{children}</BaseQueryClientProvider>
}

export default QueryClientProvider
